import { render, staticRenderFns } from "./cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc_h5.vue?vue&type=template&id=414542a9&scoped=true&"
import script from "./cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc_h5.vue?vue&type=script&lang=js&"
export * from "./cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc_h5.vue?vue&type=script&lang=js&"
import style0 from "./cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc_h5.vue?vue&type=style&index=0&id=414542a9&scoped=true&lang=less&"
import style1 from "./cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc_h5.vue?vue&type=style&index=1&id=414542a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414542a9",
  null
  
)

export default component.exports